import * as moment from "moment-timezone";

const IndiaTime = (date) => moment(date).tz("Asia/Kolkata");

export default IndiaTime;
